<template>
  <div>
    <div v-if="isShowPage">
      <el-header ref="header" class="header" style="height: auto;margin-bottom: 10px">
        <el-form :inline="true" :model="searchForm" ref="searchFormRef" class="demo-form-inline">
          <div id="searchBox">
            <el-form-item label="" prop="company">
              <el-input placeholder="请输入公司名称" v-model="searchForm.company" @keydown.enter.native="handleSearchBtn"/>
            </el-form-item>
            <el-form-item label="" prop="xhname">
              <el-input placeholder="请输入型号" v-model="searchForm.xhname" @keydown.enter.native="handleSearchBtn"/>
            </el-form-item>
            <el-form-item label="" prop="source">
              <el-input placeholder="请输入品牌" v-model="searchForm.source" @keydown.enter.native="handleSearchBtn"/>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button type="text" style="margin-left:10px" id="closeSearchBtn" @click="closeSearch">
              {{ word }}
              <i :class="showAll ? 'el-icon-arrow-up ': 'el-icon-arrow-down'"></i>
            </el-button>
            <el-button type="primary" size="small" @click="handleSearchBtn()" icon="el-icon-search">搜索
            </el-button>
            <el-button size="small" @click="handleResetBtn" icon="el-icon-refresh">重置</el-button>
          </el-form-item>
        </el-form>
      </el-header>
      <div class="custom-table search-table">
        <el-table border fit highlight-current-row class="customer-table" :data="list">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <Expand :activeName="activeName" :data="scope.row" />
            </template>
          </el-table-column>
          <el-table-column label="ID" prop="id"></el-table-column>
          <el-table-column label="订单号" prop="orderid"></el-table-column>
          <el-table-column label="型号" prop="xhname" width="180"></el-table-column>
          <el-table-column label="品牌" prop="source"></el-table-column>
          <el-table-column label="数量" prop="num"></el-table-column>
          <el-table-column label="单价" prop="price"></el-table-column>
          <el-table-column label="货期" prop="sendtime"></el-table-column>
          <el-table-column label="报价公司" prop="company" width="270"></el-table-column>
          <el-table-column label="操作">
            <template v-slot="scope">
              <el-popconfirm
                iconColor="red"
                @confirm="handleDelete(scope.row,scope.$index)"
                title="确认删除此条数据吗？"
              >
                <el-button slot="reference" type="danger" size="small" class="el-icon-delete">删除</el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"
                       :current-page="selectPage.pageNum" :page-sizes="[20, 50, 100, 200]"
                       :page-size="selectPage.pageSize"
                       background
                       layout="total, sizes, prev, pager, next, jumper" :total="allNum"
                       style="margin-top: 14px;margin-bottom:14px"
        >
        </el-pagination>
      </div>
    </div>
    <el-empty description="暂无权限查看数据" v-else class="customer-category_empty" />
  </div>
</template>
<script>
import { computed, defineComponent, onMounted, reactive, ref, getCurrentInstance } from '@vue/composition-api'
import PageWrapper from '@/components/PageWrapper/index.vue'
import request from '@/utils/request'
import { Message } from 'element-ui'
import Expand from './expand.vue'

export default defineComponent({
  components: { PageWrapper, Expand },
  props: {
    activeName: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const instance = getCurrentInstance()
    const username = instance.proxy.$store.getters.name
    const showAll = ref(false)
    const isShowPage = ref(false)
    const selectPage = reactive({
      pageNum: 1,
      pageSize: 20
    })
    const allNum = ref(1)
    const list = ref([])
    const searchFormRef = ref(null)
    const searchForm = reactive({
      company: '',
      xhname: '',
      source: ''
    })

    const word = computed(() => {
      if (!showAll.value) {
        return '展开'
      } else {
        return '收起'
      }
    })

    const pageSizeChange = (e) => {
      selectPage.pageSize = e
      getList()
    }
    const pageCurrentChange = (e) => {
      selectPage.pageNum = e
      getList()
    }

    const closeSearch = () => {
      showAll.value = !showAll.value
    }

    const handleSearchBtn = () => {
      selectPage.pageNum = 1
      getList()
    }

    const handleResetBtn = () => {
      searchFormRef.value.resetFields()
      getList()
    }


    const handleDelete = (scope, index) => {
      request({
        url: 'customer_quotation_delete.yy',
        method: 'post',
        data: { id: scope.id }
      }).then(res => {
        if (res.code == 200) deleteRow(index)
      }).catch(err => {
        Message({ message: err, type: 'error' })
      })
    }

    const deleteRow = (index) => {
      list.value.splice(index, 1)
    }
    const getList = () => {
      request({
        url: 'customer_quotation_list.yy',
        method: 'post',
        params: selectPage,
        data: {
          username: username,
          type: props.activeName,
          ...searchForm
        }
      }).then(res => {
        if (res.code == 200) {
          list.value = res.data
          allNum.value = res.total
          isShowPage.value = true
        } else {
          isShowPage.value = false
          Message({ type: 'error', message: res.msg })
        }
      })
    }

    onMounted(() => {
      getList()
    })


    return {
      isShowPage,
      username,
      searchFormRef,
      searchForm,
      showAll,
      allNum,
      selectPage,
      word,
      list,
      closeSearch,
      handleResetBtn,
      handleSearchBtn,
      pageSizeChange,
      pageCurrentChange,
      handleDelete,
      deleteRow
    }
  }
})
</script>
<style scoped>
.el-icon-delete {
  span {
    margin-left: 4px;
  }
}

.customer-category_empty {
  height: calc(100vh - 130px);
}

</style>

